var { NotificationManager } = require('react-native').NativeModules;

module.exports = NotificationManager;
